import { CommonWindow } from '@core/domain/models/common-window.model';

export const PAGE_REFERRER_KEY = 'page_referer';

export const setPageReferrer = (_url: string, commonWindow: CommonWindow): void => {
    const url = new URL(_url);
    const pageLocation = url.pathname + url.hash;

    commonWindow.localStorage.setItem(PAGE_REFERRER_KEY, pageLocation);
};

export const getPageReferrer = (commonWindow: CommonWindow): string => {
    if (!commonWindow?.localStorage) {
        return undefined;
    }

    const pageReferrer = commonWindow.localStorage.getItem(PAGE_REFERRER_KEY);
    return pageReferrer ? commonWindow.location.origin + pageReferrer : undefined;
};

export const clearPageReferrer = (commonWindow: CommonWindow): void => {
    commonWindow.localStorage.removeItem(PAGE_REFERRER_KEY);
};

export const initBeforeUnloadListener = (commonWindow: CommonWindow): void => {
    commonWindow.addEventListener('beforeunload', () => {
        clearPageReferrer(commonWindow);
    });
};
